import { render, staticRenderFns } from "./project-step-identification.vue?vue&type=template&id=2ce721ac&"
import script from "./project-step-identification.vue?vue&type=script&lang=js&"
export * from "./project-step-identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports